//React Components and Hooks
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import React from "react";
//Material UI Components
import AnalyticCard from "../../components/cards/AnalyticCard";
//Custom Components

const DevPage = () => {
  return (
    <Container>
      <h1>Dev Page! Running Tests on loading data via react redux....</h1>
      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
        <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 calc(50% - 12px)', lg: '1 1 calc(33.33% - 16px)', xl: '1 1 calc(33.33% - 16px)' } }}>
          <AnalyticCard title="User Item" />
        </Box>
      </Box>
    </Container>
  );
};

export default DevPage;
